export default __webpack_public_path__ + "static/media/new-3.1363c80e.png";